export const routes = {
  index: '/',
  projectLibrary: 'project-library',
  callback: '/callback',
  logout: '/logout',
};

export const documentTitleMap = {
  index: 'Home',
  projectLibrary: 'Project Library',
  support: 'Support',

  entities: {
    document: 'Entities',
    page: 'Entities'
  },
  reports: {
    document: 'Reports: Reports',
    page: 'Reports',
  },
  reportDocumentsGenerated: {
    document: 'Reports:Documents Generated',
    page: 'Documents Generated',
  },
  reportFilesDownloaded: {
    document: 'Reports:Files Downloaded',
    page: 'Files Downloaded',
  },
  newWorkspace: {
    document: 'New Workspace',
    page: 'New Workspace',
  }
};
